import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
// import ImportIcon from "components/import-export/import-icon"
// import ExportIcon from "components/import-export/export-icon"
// import Import from "components/import-export/import"
import TenantGroupsTable from "components/recoveries/tenant-groups/tenant-groups-table"
// Data
import api_match from "data/interface/api"
// import importService from "data/import"
import tenantGroupService from "data/tenant-group"
import propertyService from 'data/property'
import { alphanum } from "components/table/lib/sort"
//Styles
import { TenantGroups_s } from "components/recoveries/tenant-groups/tenant-groups-styles"
import { AddIcon } from "images/icons/tools"
import rentrollService from 'data/rent-roll'

const TenantGroups: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [rentrollData, setRentrollData] = useState<object[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [rentrollInitSort, setRentrollInitSort] = useState<boolean>(false)
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [property, setProperty] = useState<object|null>(null);
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const tableId = "tenant-groups-table"

  useEffect(() => {
    // importService.stream().subscribe(data => {
    //   toggleShowImport(data['showImport'])
    // })

    const rentrollSubscriptioin = rentrollService.stream().subscribe(data => {
      api_match(
        data,
        init  => setRentrollData(init.value),
        ok    => {
          if(!rentrollInitSort && ok.value.length) { // sort only on first load
            setRentrollData([...ok.value].sort((a, b) => alphanum(_.get(a, "suite"), _.get(b, "suite"))))
            setRentrollInitSort(true)
          } else {
            setRentrollData(ok.value)
          }
        },
        err   => {
          setRentrollData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const tenantGroupsSubscription = tenantGroupService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          if(!initSort && ok.value.length) { // sort only on first load
            setData([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setInitSort(true)
          } else {
            setData(ok.value)
          }
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        const currentProperty = _.find(data.value, {propertyid: data.current});
        setProperty(currentProperty)
      }
      switch (data.state) {
        case 'ok':
          setPropertyId(data.current)
          break
      }
    })

    return function cleanup() {
      tenantGroupsSubscription.unsubscribe()
      propertySubscription.unsubscribe()
      rentrollSubscriptioin.unsubscribe()
    }
  }, [initSort])

  useEffect(() => {
    if (_.isNil(propertyId)) return

    tenantGroupService.fetchTenantGroups(propertyId);
    propertyService.fetchProperty(propertyId);
    rentrollService.fetchRentRoll(propertyId, false);

  }, [propertyId])

  const Add = () => {
    return (
      <a onClick={() => tenantGroupService.create(propertyService.getStoredPropertyId())}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  return (
    <TenantGroups_s>
      <Toolbar>
        <Add />
        {/* <ImportIcon />
        <ExportIcon template="tenantgroup" /> */}
      </Toolbar>
      {/* { showImport && <Import /> } */}
      { data && property && rentrollData && !showImport && <TenantGroupsTable tableId={tableId} data={data} property={property} rentrollData={rentrollData} /> }
    </TenantGroups_s>
  )
}

export default TenantGroups
